import { Component } from '@angular/core';
import { ConfigManagerService } from '../../shared/services/config-manager.service';

@Component({
    standalone: false,
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
    inputs: ['isLight']
})
export class FooterComponent {
    isLight: boolean;
    version: string;
    businessAppUrl: string;
    currentYear: number = new Date().getFullYear();

    constructor(configManagerService: ConfigManagerService) {
        this.version = configManagerService.version;
        this.businessAppUrl = configManagerService.apps.business;
    }
}
